import { render } from "./WalletWithdrawal.vue?vue&type=template&id=a442e51c"
import script from "./WalletWithdrawal.vue?vue&type=script&lang=js"
export * from "./WalletWithdrawal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__